// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { colors } from '../../shared/styles';

import { REPORT_TYPES, getExportDownload } from '../../redux/reducers/exports';

import Button from '../../components/shared/Button';

const StyledExport = styled.div`
    padding: 40px;
    max-width: 980px;

    & .export-list {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
    }

    & li {
        display: block;
        flex-grow: 1;
        background: ${colors.white};
        margin-right: 20px;
        padding: 20px 0;
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        text-align: center;
    }

    & h3 {
        margin-top: 0;
    }
`;

class Export extends Component {
    getDataExport: Function;

    constructor(props) {
        super(props);

        this.getDataExport = this.getDataExport.bind(this);
    }

    getDataExport(reportType) {
        this.props.dispatch(getExportDownload(reportType));
    }

    render() {
        const { fetching } = this.props;

        const downloadText = fetching ? 'Please wait...' : 'Download';

        return (
            <StyledExport>
                <h3>Data Export</h3>

                <ul className="export-list">
                    <li>
                        <h3>Contact Requests</h3>
                        <p>
                            Download all individual property specific contact
                            requests.
                        </p>
                        <Button
                            onClick={e => {
                                this.getDataExport(
                                    REPORT_TYPES.CONTACT_REQUESTS
                                );
                            }}
                            disabled={fetching}
                        >
                            {downloadText}
                        </Button>
                    </li>
                    <li>
                        <h3>Contact Page Form Submissions</h3>
                        <p>
                            Download all submissions from the Contact Page of
                            the website.
                        </p>
                        <Button
                            onClick={e => {
                                this.getDataExport(
                                    REPORT_TYPES.CONTACT_REGION_REQUESTS
                                );
                            }}
                            disabled={fetching}
                        >
                            {downloadText}
                        </Button>
                    </li>
                </ul>
            </StyledExport>
        );
    }
}

const mapStateToProps = state => {
    return {
        fetching: state.exports.fetching,
    };
};

export default connect(mapStateToProps)(Export);



// WEBPACK FOOTER //
// ./src/containers/Export/Export.js